import SuccessView              from 'scripts/defa/basic/view-success-view';
import SubscriptionTransferForm from 'scripts/defa/subscriptions/view-subscription-transfer-form';
/**
 * defa.views.SubscriptionTransferFlow
 * A flow to manage transfers of subscriptions.
 * @version 1.2.0
 */
import Flow                     from 'scripts/poppet/flow';
import template                 from 'templates/subscriptionTransferFlow.jst.html';

const selectors                = {
	region: '[data-region=transfer-container]',
};
const SubscriptionTransferFlow = Flow.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.region,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers as the view is attached to the DOM.
	 * @void
	 */
	onAttach: function () {
		this.listenTo( this.model, 'transferred', this.onSubscriptionTransferred );
	},
	
	/**
	 * Triggers when a childView informs that the subscription is transferred.
	 * @void
	 */
	onSubscriptionTransferred: function ( subscription, email ) {
		this.email = email;
		this.dispatch();
	},
	
	/**
	 * Triggers when a successView asks to close up.
	 * @void
	 */
	onChildviewSuccessClose: function ( childView ) {
		childView.animateOut();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Logically flows the views for a subscription transfer.
	 * @void
	 */
	dispatch: function () {
		
		let fn = false;
		
		if ( !this.email ) {
			fn = this._showTransferForm;
		}
		
		if ( this.email ) {
			fn = this._showTransferSuccess;
		}
		
		if ( _.isFunction( fn ) ) {
			fn.call( this );
		}
		
	},
	
	/**
	 * Places a transfer form in this flow's container.
	 * @void
	 */
	_showTransferForm: function () {
		let subscriptionTransferForm = new SubscriptionTransferForm( this.options );
		this.showChildView( 'container', subscriptionTransferForm );
	},
	
	/**
	 * Places a success-view in this flow's container.
	 * @void
	 */
	_showTransferSuccess: function () {
		let successView = new SuccessView( {
			context: 'subscription:transfer',
			email  : this.email,
		} );
		this.showChildView( 'container', successView );
	},
	
} );

export default SubscriptionTransferFlow;